import getFeature from '../features';

const limit = getFeature('attachment_size_limit');

const isFileOverlarge = (file: { size: number }, maxSizeMB: number = limit) =>
  file.size > maxSizeMB * 1000 * 1000;

export const overlargeImageMessage = limit
  ? `Image exceeded the maximum upload size of ${limit}MB`
  : 'Image exceeded the maximum upload size';

export default isFileOverlarge;
